import React from "react";
import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import Layout from "./Template/layout";
import SignUp from "./pages/auth/signup";
import SignIn from "./pages/auth/signin";
import ForgetPassword from "./pages/auth/forgetpassword";
import Resetpassword from "./pages/auth/resetpassword";
import PrivateRoute from "./routes/PrivateRoute";
import routes from "./routes/Routes";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterMoment } from "@mui/x-date-pickers-pro/AdapterMoment";
import SnackBar from "./components/Snackbar";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <SnackBar />
        <ToastContainer autoClose={2000} />
        {/* localization provider for google adress autocomplete */}
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Routes>
            <Route path="/login" element={<SignIn />} />
            <Route path="/forgetpassword" element={<ForgetPassword />} />
            <Route path="/resetpassword/:token" element={<Resetpassword />} />
            <Route path="/signup/:token" element={<SignUp />} />
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Layout />}>
                <Route path="/" element={<Navigate to="/dashboard" />} />
                {routes.map((route, index) => {
                  return (
                    route.element && (
                      <Route
                        key={index}
                        path={route.path}
                        element={<route.element />}
                      />
                    )
                  );
                })}
              </Route>
            </Route>
          </Routes>
        </LocalizationProvider>
      </Provider>
    </div>
  );
}

export default App;
